import api from './api';

const deleteHotsite = async (payload: Services.Hotsites.DeleteHotsite) => (
  api.delete('hotsites', { data: payload })
);

const getCategories = async (planId: number | string) => (
  api.get<Services.Hotsites.Response.GetCategories>(`customerplanscategory/${planId}`)
);

const getHotsites = async (payload: Services.Hotsites.GetHotsites) => (
  api.get<Services.Hotsites.Response.GetHotsites>('hotsites', { params: payload })
);

const postHotsite = async (payload: Services.Hotsites.PostHotsite) => (
  api.post('hotsite', payload)
);

const putHotsite = async (payload: Services.Hotsites.PutHotsite) => (
  api.put('hotsite', payload)
);

export default {
  deleteHotsite,
  getCategories,
  getHotsites,
  postHotsite,
  putHotsite,
};
